import { CheckPermission, Permission } from '@/features/auth'
import { Events } from '@/features/order'

function EventList() {
  return (
    <CheckPermission permissions={[Permission.ORDER_READ]} redirect="/goodies">
      <Events />
    </CheckPermission>
  )
}

export default EventList
